import {
  Box,
  Button,
  Card,
  Container,
  FormControl,
  InputLabel,
  MenuItem,
  Select,
  Typography,
} from "@mui/material";
import React, { useState } from "react";
import { Link } from "react-router-dom";
import DesktopDatePicker from "@mui/lab/DesktopDatePicker";
import AdapterDateFns from "@mui/lab/AdapterDateFns";
import TextField from "@mui/material/TextField";
import SearchIcon from "@mui/icons-material/Search";
import moment from "moment";
import api from "../../../components/services/api";
import LocalizationProvider from "@mui/lab/LocalizationProvider";
import { useEffect } from "react";
import { DataGrid } from "@mui/x-data-grid";
import mime from "mime";
import { saveAs } from "file-saver";

export default function DailyMovementReport() {
  const [dateStart, setDateStart] = useState(
    new Date(Date.now() - 3600 * 1000 * 24)
  );
  const [dateEnd, setDateEnd] = useState(new Date());
  const [loading, setLoading] = useState(false);
  const [searchText, setSearchText] = useState("");
  const [data, setData] = useState([]);
  const [groupData, setGroupData] = useState([]);
  const [toCountry, setToCountry] = useState("all");
  const [location, setLocation] = useState([]);
  const [locationFilter, setLocationFilter] = useState([]);
  const [country, setCountry] = useState([]);
  const [toAction, setToAction] = useState("all");
  const [toCountryOut, setToCountryOut] = useState("all");
  const [locationOut, setLocationOut] = useState([]);
  const [locationFilterOut, setLocationFilterOut] = useState([]);
  const [countryOut, setCountryOut] = useState([]);
  const [toActionOut, setToActionOut] = useState("all");
  const [board, setBoard] = useState("all");
  const columns = [
    { field: "Status", headerName: "Status", width: 200 },
    { field: "ShippingLineCode", headerName: "Shipping Line Code", width: 200 },
    { field: "ContainerNo", headerName: "Container No.", width: 200 },
    { field: "Size", headerName: "Size", width: 200 },
    { field: "Type", headerName: "Type", width: 200 },
    { field: "GateInbound", headerName: "Gate Inbound", width: 200 },
    { field: "VoyInbound", headerName: "Voy Inbound", width: 200 },
    {
      field: "DateDischargeInbound",
      headerName: "Discharge Inbound",
      width: 200,
      renderCell: (value) => {
        return moment(value.row.DateDischargeInbound).format("yyyy/MM/DD");
      },
    },
    { field: "GateOutbound", headerName: "Gate Outbound", width: 200 },
    { field: "VoyOutbound", headerName: "Voy Outbound", width: 200 },
    {
      field: "DateLoadingOutbound",
      headerName: "Loading Outbound",
      width: 200,
      renderCell: (value) => {
        return moment(value.row.DateLoadingOutbound).format("yyyy/MM/DD");
      },
    },
  ];

  const search1 = async () => {
    const params = new URLSearchParams();

    if (dateStart)
      params.append("startDate", moment(dateStart).format("yyyy-MM-DD"));
    if (dateEnd) params.append("endDate", moment(dateEnd).format("yyyy-MM-DD"));
    if (toActionOut !== "all") params.append("outboundLocationId", toActionOut);
    if (toAction !== "all") params.append("inboundLocationId", toAction);
    if (board !== "all") params.append("groupId", board);
    if (searchText) params.append("keyword", searchText);
    const data = await api.get(`/api/report/daily-movement/list?${params}`);

    const result = data?.data.map((item, i) => {
      return {
        ...item,
        index: i + 1,
      };
    });

    setData(result);
  };

  const getdata = async () => {
    const params = new URLSearchParams();

    if (dateStart)
      params.append("startDate", moment(dateStart).format("yyyy-MM-DD"));
    if (dateEnd) params.append("endDate", moment(dateEnd).format("yyyy-MM-DD"));

    const data = await api.get(`/api/report/daily-movement/list?${params}`);

    const result = data?.data.map((item, i) => {
      return {
        ...item,
        index: i + 1,
      };
    });
    setData(result);
  };
  const getCountry = async () => {
    try {
      const res = await api.get("api/country/list");
      const data = await res.data;
      if (res.meta.status === true) {
        setCountry(data.filter((x) => x?.Status === true));
        setCountryOut(data.filter((x) => x?.Status === true));
      }
    } catch (e) {
      console.log(e);
    }
  };
  const getLocation = async () => {
    try {
      const res = await api.get("api/location/list");
      const data = await res.data;
      if (res.meta.status === true) {
        setLocation(data.filter((x) => x?.Status === true));
        setLocationFilter(data.filter((x) => x?.Status === true));
        setLocationOut(data.filter((x) => x?.Status === true));
        setLocationFilterOut(data.filter((x) => x?.Status === true));
      }
    } catch (e) {
      console.log(e);
    }
  };
  const getMasterGroup = async () => {
    const res = await api.get(`api/master/group`);
    const data = await res.data;
    if (res.meta.status === true) {
      setGroupData(data.data);
    }
  };
  useEffect(() => {
    getCountry();
    getLocation();
    getdata();
    getMasterGroup();
  }, []);
  useEffect(() => {
    if (toCountry !== "all") {
      const filterLocation = location?.filter(
        (item) => item.CountryId === toCountry
      );
      setLocationFilter(filterLocation);
      setToAction(filterLocation[0]?.LocationId);
    } else {
      setLocationFilter(location);
    }
  }, [toCountry]);

  useEffect(() => {
    if (toCountryOut !== "all") {
      const filterLocationOut = locationOut?.filter(
        (item) => item.CountryId === toCountryOut
      );
      setLocationFilterOut(filterLocationOut);
      setToActionOut(filterLocationOut[0]?.LocationId);
    } else {
      setLocationFilterOut(locationOut);
    }
  }, [toCountryOut]);
  return (
    <LocalizationProvider dateAdapter={AdapterDateFns}>
      <Card variant="outlined" style={{ padding: "20px", margin: "25px" }}>
        <h6 style={{ marginTop: "10px" }} className="textcolorgreen">
          รายงาน Daily Movement
        </h6>
        <h3 style={{ marginTop: "10px" }} className="textcolordarkblue">
          Daily Movement Report
        </h3>
        <div
          style={{
            display: "flex",
            justifyContent: "flex-end",
            width: "100%",
            marginBottom: "10px",
          }}
        >
          <FormControl
            size="small"
            sx={{
              width: "15%",
              marginRight: "10px",
            }}
          >
            <InputLabel>Outbound Country</InputLabel>
            <Select
              label="Outbound Country"
              value={toCountryOut}
              InputLabelProps={{ shrink: true }}
              onChange={(e) => {
                setToCountryOut(e.target.value);
              }}
              // disabled={values.liners !== ""}
            >
              <MenuItem value={"all"}>ทั้งหมด</MenuItem>
              {countryOut?.map((x) => (
                <MenuItem value={x?.CountryId}>{x?.CountryName}</MenuItem>
              ))}
            </Select>
          </FormControl>
          <FormControl
            size="small"
            sx={{
              width: "15%",
              marginRight: "10px",
            }}
          >
            <InputLabel>Outbound Location</InputLabel>
            <Select
              label="Outbound Location"
              value={toActionOut}
              InputLabelProps={{ shrink: true }}
              onChange={(e) => {
                setToActionOut(e.target.value);
              }}
              // disabled={values.liners !== ""}
            >
              <MenuItem value={"all"}>ทั้งหมด</MenuItem>
              {locationFilterOut?.map((x) => (
                <MenuItem value={x?.LocationId}>{x?.LocationName}</MenuItem>
              ))}
            </Select>
          </FormControl>
          <FormControl
            size="small"
            sx={{
              width: "15%",
              marginRight: "10px",
            }}
          >
            <InputLabel>Board</InputLabel>
            <Select
              label="Board"
              value={board}
              InputLabelProps={{ shrink: true }}
              onChange={(e) => {
                setBoard(e.target.value);
              }}
              // disabled={values.liners !== ""}
            >
              <MenuItem value={"all"}>ทั้งหมด</MenuItem>
              {groupData?.map((x) => (
                <MenuItem value={x?.GroupId}>{x?.GroupName}</MenuItem>
              ))}
            </Select>
          </FormControl>
          <FormControl
            size="small"
            sx={{
              width: "15%",
              marginRight: "10px",
            }}
          >
            <InputLabel>Inbound Country</InputLabel>
            <Select
              label="Inbound Country"
              value={toCountry}
              InputLabelProps={{ shrink: true }}
              onChange={(e) => {
                setToCountry(e.target.value);
              }}
              // disabled={values.liners !== ""}
            >
              <MenuItem value={"all"}>ทั้งหมด</MenuItem>
              {country?.map((x) => (
                <MenuItem value={x?.CountryId}>{x?.CountryName}</MenuItem>
              ))}
            </Select>
          </FormControl>
          <FormControl
            size="small"
            sx={{
              width: "15%",
            }}
          >
            <InputLabel>Inbound Location</InputLabel>
            <Select
              label="Inbound Location"
              value={toAction}
              InputLabelProps={{ shrink: true }}
              onChange={(e) => {
                setToAction(e.target.value);
              }}
              // disabled={values.liners !== ""}
            >
              <MenuItem value={"all"}>ทั้งหมด</MenuItem>
              {locationFilter?.map((x) => (
                <MenuItem value={x?.LocationId}>{x?.LocationName}</MenuItem>
              ))}
            </Select>
          </FormControl>
        </div>
        <div
          style={{ display: "flex", justifyContent: "flex-end", width: "100%" }}
        >
          <TextField
            value={searchText}
            onChange={(e) => setSearchText(e.target.value)}
            size="small"
            id="outlined-basic"
            label="Search"
            variant="outlined"
          />

          <DesktopDatePicker
            label="Date Start"
            value={dateStart}
            onChange={(newValue) => {
              setDateStart(moment(newValue).format("yyyy-MM-DD"));
            }}
            inputFormat="yyyy/MM/dd"
            minDate={new Date("2017-01-01")}
            renderInput={(params) => (
              <TextField
                size="small"
                style={{ width: "200px", marginLeft: "10px" }}
                {...params}
              />
            )}
          />
          <DesktopDatePicker
            label="Date End"
            value={dateEnd}
            onChange={(newValue) => {
              setDateEnd(moment(newValue).format("yyyy-MM-DD"));
            }}
            inputFormat="yyyy/MM/dd"
            minDate={new Date(dateStart)}
            renderInput={(params) => (
              <TextField
                size="small"
                style={{ width: "200px", marginLeft: "10px" }}
                {...params}
              />
            )}
          />

          <Button
            style={{
              backgroundColor: "#0d6efd",
              color: "#fafafa",
              marginLeft: "10px",
            }}
            onClick={search1}
          >
            <SearchIcon />
          </Button>
          <Button
            variant="contained"
            disabled={loading}
            style={{
              textTransform: "none",
              backgroundColor: "#007BFF",
              marginLeft: "10px",
            }}
            onClick={async () => {
              setLoading(true);
              const params = new URLSearchParams();

              if (dateStart)
                params.append(
                  "startDate",
                  moment(dateStart).format("yyyy-MM-DD")
                );
              if (dateEnd)
                params.append("endDate", moment(dateEnd).format("yyyy-MM-DD"));
              if (toActionOut !== "all")
                params.append("outboundLocationId", toActionOut);
              if (toAction !== "all")
                params.append("inboundLocationId", toAction);
              if (board !== "all") params.append("groupId", board);
              if (searchText) params.append("keyword", searchText);
              await api
                .get(
                  `/api/report/daily-movement/download?${params}`,
                  {
                    responseType: "blob",
                    timeout: 50000,
                  }
                )
                .then((blobFile) => {
                  const blobFileRes = new File([blobFile?.data], "test.xlsx", {
                    type: mime.getType(".xlsx"),
                  });

                  // window.open(
                  //   URL.createObjectURL(blobFileRes, "test.csv"),
                  //   "_blank"
                  // );
                  saveAs(blobFileRes, "Daily Movement Report.xlsx");
                  setLoading(false);
                });
            }}
          >
            Download
          </Button>
        </div>
        <Box sx={{ height: "700px", marginTop: "25px" }}>
          <DataGrid
            getRowId={(r) => r.index}
            rows={data}
            columns={columns}
            pageSize={10}
            rowsPerPageOptions={[10]}
            hideFooterSelectedRowCount
            disableColumnFilter
            disableColumnMenu
          />
        </Box>
      </Card>
    </LocalizationProvider>
  );
}
